module.exports = __webpack_public_path__ + "img/portfolio-08-481x325.851bfdb5.jpg";